import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { Wifi, User } from 'lucide-react';
import api from '../services/api';

export default function PortalLogin() {
  const [dniCuit, setDniCuit] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await api.post('/auth/cliente/login', { dniCuit });
      localStorage.setItem('cliente_token', response.data.access_token);
      localStorage.setItem('cliente_data', JSON.stringify(response.data.cliente));
      toast.success('Bienvenido al Portal de PilarNet!');
      navigate('/portal');
    } catch (error) {
      toast.error(error.response?.data?.message || 'Cliente no encontrado');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-600 to-primary-800">
      <div className="bg-white p-8 rounded-2xl shadow-2xl w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-primary-100 rounded-full mb-4">
            <Wifi size={32} className="text-primary-600" />
          </div>
          <h1 className="text-3xl font-bold text-gray-900">PilarNet</h1>
          <p className="text-gray-500 mt-2">Portal del Cliente</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              DNI / CUIT
            </label>
            <div className="relative">
              <User className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={20} />
              <input
                type="text"
                value={dniCuit}
                onChange={(e) => setDniCuit(e.target.value)}
                className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                placeholder="Ingresa tu DNI o CUIT"
                required
              />
            </div>
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 px-4 bg-primary-600 hover:bg-primary-700 text-white font-medium rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? 'Verificando...' : 'Ingresar'}
          </button>
        </form>
        <div className="mt-6 text-center">
          <a href="/login" className="text-sm text-primary-600 hover:text-primary-700">
            Soy administrador → Ir al Panel Admin
          </a>
        </div>
      </div>
    </div>
  );
}
